import Box from '@mui/material/Box'
import styled from '@mui/material/styles/styled'

export const Title = styled(Box, {
  name: 'Title',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro Semibold';
  font-size: 14px;
  color: #222222;
  margin-bottom: 12px;
`
